import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=15cf6c3a&"
import script from "./InputItem.vue?vue&type=script&lang=js&"
export * from "./InputItem.vue?vue&type=script&lang=js&"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=15cf6c3a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports